import { render, staticRenderFns } from "./document-info-invoice.vue?vue&type=template&id=66452302"
import script from "./document-info-invoice.vue?vue&type=script&lang=js"
export * from "./document-info-invoice.vue?vue&type=script&lang=js"
import style0 from "./document-info-invoice.vue?vue&type=style&index=0&id=66452302&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports